import BaseApi from "../BaseApi";
import { headers } from "../ApiSettings";

class Auth extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  getValidation(params) {
    return this.httpService.get("security/validate", { headers, params });
  }

  signInUser(data) {
    return this.httpService.post("Accounts/signIn-user", data, { headers });
  }

  authResetPassword(data) {
    return this.httpService.post("Accounts/send-code-forget-password", data, {
      headers,
    });
  }

  authSingUp(data) {
    return this.httpService.post("Accounts/send-code-login-token-register-panel", data, {
      headers,
    });
  }

  verifyAuthSignIn(data, header) {
    return this.httpService.post("Accounts/verify-twofactor-user", data, {
      headers: header,
    });
  }

  sendCode(data, header) {
    return this.httpService.post("Accounts/send-Code-twofactor-user", data, {
      headers: header,
    });
  }

  verifyAuthResetPassword(data, header) {
    return this.httpService.post("Accounts/verify-code-forget-password", data, {
      headers: header,
    });
  }

  postNewPassword(data) {
    return this.httpService.post(
        "Accounts/change-password-new-with-forget-password",
        data,
        {
          headers,
        }
    );
  }

  verifyAuthSignUp(data) {
    return this.httpService.post("Accounts/verify-code-login-token", data, {
      headers,
    });
  }

  getUserData(params) {
    return this.httpService.get("Accounts/user-login", { headers, params });
  }


  postRegister(data, token) {
    return this.httpService.post("Accounts/register-company-user-group-definition", data, {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`
      },
    });
  }
}

const AuthService = new Auth();
export default AuthService;
